/**
 * Normalize item components (modifiers OR selected_variations) into
 * printable lines. Single source of truth for all receipt renderers:
 * receiptBuilder.js, silentPrintService.js, printService.js.
 *
 * modifiers wins when present (POS flow); selected_variations is the
 * fallback (public menu flow). Returns [{ label, price }] where price
 * is the unit price when > 0, or null when the component is included.
 */
export function getItemComponents(item) {
  if (item?.modifiers && item.modifiers.length > 0) {
    return item.modifiers.map(mod => ({
      label: mod.name || String(mod),
      price: mod.price > 0 ? mod.price : null,
    }));
  }
  if (item?.selected_variations && item.selected_variations.length > 0) {
    return item.selected_variations.map(v => ({
      label: (v.quantity || 1) > 1 ? `${v.quantity}× ${v.name}` : v.name,
      price: v.price > 0 ? v.price : null,
    }));
  }
  return [];
}

/**
 * Single-line description ("2× Hot Philadelphia, Vulcan Salmón") for the
 * fiscal receipt. Prefers the POS-provided modifier_description.
 */
export function getComponentsDescription(item) {
  if (item?.modifier_description) return item.modifier_description;
  return getItemComponents(item).map(c => c.label).join(", ");
}
